module.exports = __webpack_public_path__ + "static/media/sculpture1.ad028986.jpg";